
define('ldsh!modules/editor/templates/elements/video', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="embed-container js-videocontent">\n</div>';

}
return __p
};});

